module.exports = __webpack_public_path__ + "static/media/magnifying-glass-circle~mZlPFzGE.d5b3c7ec.svg";